import { injectable, decorate, inject } from 'inversify';
import 'reflect-metadata';
import { SERVICE_IDENTIFIER } from 'constants/identifiers';
import { NetworkError, TeamError } from 'errors';

@injectable()
class TeamService {
  constructor(apiService) {
    this.apiService = apiService;
  }

  async getTeams() {
    try {
      return await this.apiService.get('/teams');
    } catch (e) {
      if (e instanceof NetworkError) {
        throw new TeamError(e.message);
      }

      throw e;
    }
  }
}

decorate(inject(SERVICE_IDENTIFIER.ApiService), TeamService, 0);

export default TeamService;
